import { useMutation } from '@apollo/client';
import { Setting } from '../../shared/types';
import { CITRIN_UPDATE_SETTING, UpdateSettingRequest, UpdateSettingResponse } from '..';

type UpdateMutationFunction = (request: Setting) => Promise<Setting>;
export const useUpdateSettingMutation = (): { mutation: UpdateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<UpdateSettingResponse, UpdateSettingRequest>(CITRIN_UPDATE_SETTING);

    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_updateSetting;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
